"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_ATTRS = exports.DATA_HOOKS = void 0;
exports.DATA_HOOKS = {
    ERROR_TOOLTIP_ICON: 'counter-error-icon',
    ERROR_TOOLTIP_ICON_WRAPPER: 'counter-popover-element',
    PLUS_BUTTON: 'counter-plus-button',
    MINUS_BUTTON: 'counter-minus-button',
};
exports.DATA_ATTRS = {
    DISABLED: 'data-disabled',
    ERROR: 'data-error',
};
//# sourceMappingURL=dataKeys.js.map